import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import { Link } from "gatsby"
import {
  BeakerIcon,
  ZapIcon,
  GearIcon,
  DatabaseIcon,
  CodeIcon,
  LightBulbIcon,
  GlobeIcon,
  MarkGithubIcon,
  RocketIcon,
  UnlockIcon,
  ShareAndroidIcon,
  GraphIcon,
  BroadcastIcon,
  BookIcon,
  HourglassIcon,
  MentionIcon,
  TerminalIcon,
  MailIcon,
} from "@primer/octicons-react"
import "./list.scss"

const List = () => {
  return (
    <>
      <Row className="px-0 mx-0">
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={9}
          xl={9}
          className="
          mb-xl-3 mb-lg-3 mb-md-3 
          mx-auto pb-4 px-0 shadow pnlBorder bg-light"
        >
          <h2 className="text-center py-3 mb-0 mx-auto display-4 textGradent">
            Some of my blog articals
          </h2>
          <Col className="list-tags list-center">
            <ul className="px-2">
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    JavaScript
                  </Link>
                  <span className="badge badge-pill">
                    <ZapIcon size={16} aria-label="Design icon" />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    React.JS
                  </Link>
                  <span className="badge badge-pill">
                    <BeakerIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Node.JS
                  </Link>
                  <span className="badge badge-pill">
                    <GearIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    CSS
                  </Link>
                  <span className="badge">
                    <DatabaseIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    NextJS
                  </Link>
                  <span className="badge badge-pill">
                    <CodeIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Redux
                  </Link>
                  <span className="badge">
                    <MarkGithubIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    GatsbyJS
                  </Link>
                  <span className="badge badge-pill">
                    <LightBulbIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    TypeScript
                  </Link>
                  <span className="badge">
                    <GlobeIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    SEO
                  </Link>
                  <span className="badge badge-pill">
                    <RocketIcon small={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Figma
                  </Link>
                  <span className="badge">
                    <UnlockIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    MongoDB
                  </Link>
                  <span className="badge badge-pill">
                    <ShareAndroidIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    GraphQL
                  </Link>
                  <span className="badge">
                    <GraphIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    GitHub
                  </Link>
                  <span className="badge badge-pill">
                    <BroadcastIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Bootstrap
                  </Link>
                  <span className="badge">
                    <BookIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Material-UI
                  </Link>
                  <span className="badge badge-pill">
                    <HourglassIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Animations
                  </Link>
                  <span className="badge">
                    <MentionIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    React Native
                  </Link>
                  <span className="badge badge-pill">
                    <TerminalIcon size={16} />
                  </span>
                </button>
              </li>
              <li>
                <button type="button" className="btn listBtn">
                  <Link
                    className="badge text-success transformNon"
                    to="/ComingSoon"
                    type="button"
                  >
                    Styled Components
                  </Link>
                  <span className="badge">
                    <MailIcon size={16} />
                  </span>
                </button>
              </li>
            </ul>
            <Col className="border-top mt-3 bg-success">
              <Link to="/Blog" className={`float-right pt-3`} type="button">
                <abbr title="read blog" className="customLink">
                  Go to Blog
                </abbr>
                <span className="text-danger">
                  <strong> &#62;</strong>
                </span>
              </Link>
            </Col>
          </Col>
        </Col>
      </Row>
    </>
  )
}

export default List
